import { DDI } from "callable-data-objects";
import { defineDocExtension } from "codemirror";
import { MenuSearch } from "Components/Shared";
import useCheckRole from "Hooks/APICheckRole";
import { useDDI } from "Hooks/Endpoints";
import React, { Fragment, useState } from "react";
import { Button, Dropdown, Icon, Menu, Table } from "semantic-ui-react";

type InboundNumberListProps = {
  onActiveView: Function;
};
const InboundNumberList = ({ onActiveView }: InboundNumberListProps) => {
  const { hasRole, roles } = useCheckRole();
  const { select, ddis } = useDDI();
  const [search, setSearch] = useState("");
  const filteredDDIs = ddis.filter((d: DDI) => d.name.indexOf(search) > -1);

  const exportDDIs = (format: String) => {
    const csv: string = ddis
      .map((d: DDI) => {
        if (format === "national") {
          if (d.name.startsWith("44")) {
            return `"=""0${d.name.substring(2)}"""`;
          }
          return `"=""00${d.name}"""`;
        }
        if (format === "e164") return `"=""${d.name}"""`;
        return `"=""+${d.name}"""`;
      })
      .sort()
      .join("\n");
    const url = window.URL.createObjectURL(new Blob([csv]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `numbers-${format}.csv`);
    document.body.appendChild(link);
    link.click();
    link.parentNode?.removeChild(link);
  };

  return (
    <Fragment>
      <Menu fluid stackable>
        <Menu.Item header>Inbound Numbers</Menu.Item>

        <Menu.Menu position='right'>
          <Dropdown item text='Save As..'>
            <Dropdown.Menu>
              <Dropdown.Item onClick={() => exportDDIs("national")}>
                National
              </Dropdown.Item>
              <Dropdown.Item onClick={() => exportDDIs("e164")}>
                E164
              </Dropdown.Item>
              <Dropdown.Item onClick={() => exportDDIs("e164+")}>
                E164+
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>

          {/* <Menu.Item color='blue' link onClick={() => exportDDIs()}>
            <Icon name='download' color='green' />
            Export CSV
          </Menu.Item> */}
          {(hasRole(roles.account.device.ddi.roles.allocate) ||
            hasRole(roles.account.device.ddi.roles.pool) ||
            hasRole(roles.account.device.ddi.roles.import)) && (
            <Dropdown item text='Assign New Number'>
              <Dropdown.Menu>
                {hasRole(roles.account.device.ddi.roles.pool) && (
                  <Dropdown.Item onClick={() => onActiveView("pool")}>
                    Number Pool
                  </Dropdown.Item>
                )}
                {hasRole(roles.account.device.ddi.roles.allocate) && (
                  <Dropdown.Item onClick={() => onActiveView("allocate")}>
                    Allocate
                  </Dropdown.Item>
                )}
                {hasRole(roles.account.device.ddi.roles.import) && (
                  <Dropdown.Item onClick={() => onActiveView("import")}>
                    Import
                  </Dropdown.Item>
                )}
              </Dropdown.Menu>
            </Dropdown>
          )}
          <MenuSearch
            placeholder='Search...'
            onSearch={(value: string) => setSearch(value)}
            value={search}
          />
        </Menu.Menu>
      </Menu>
      <Table celled padded stackable>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell width={15} singleLine>
              Number
            </Table.HeaderCell>
            <Table.HeaderCell width={1}>Actions</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {filteredDDIs.map((ddi: DDI) => (
            <Table.Row key={`tr-ddi-${ddi.name}`}>
              <Table.Cell singleLine>{ddi.name}</Table.Cell>
              <Table.Cell textAlign='left'>
                {hasRole(roles.account.device.ddi.roles.select) && (
                  <Button primary size='tiny' onClick={() => select(ddi.id)}>
                    View
                  </Button>
                )}
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    </Fragment>
  );
};

export default InboundNumberList;
